import moment from "moment";
import classNames from "classnames";
import useTranslations from "../../../core/i18n/useTranslations";
import useLanguage from "../../../core/i18n/useLanguage";
import { IntervalCell } from "../../../pages/Objects/ObjectAdvanced/Interactions/CustomTableCell/CustomTableCell";
import { getWeekDays } from "../../utils/userDateFormat";

import styles from "./ScheduleItem.module.css";
import Icon from "../Icon";

export const CustomSelectedDays = ({
  repeatDays,
  isFormEditable,
  endDateValue,
  startFromSunday = false,
}: {
  repeatDays: number[];
  isFormEditable: boolean;
  endDateValue: string;
  startFromSunday?: boolean;
}) => {
  const t = useTranslations();
  const language = useLanguage();
  const locale = language.currentLanguage?.region || "sv-SE";
  let days = getWeekDays(locale);
  if (startFromSunday) {
    days = [days[6], ...days.slice(0, 6)];
  }
  const weekdays = Array.from(Array(7).keys()).map((i) => ({
    label: days[i],
    isSelected: repeatDays?.includes(startFromSunday ? i + 1 : i),
  }));
  return (
    <div
      className={classNames({
        [styles.intervalWrapper]: true,
        [styles.customView]: !isFormEditable,
      })}
    >
      <Icon name="calendar" size={isFormEditable ? 16 : 24} color="Grey-300" />
      <div>
        <IntervalCell withComma={!!endDateValue} weekdays={weekdays} />
        {endDateValue && (
          <p className="fw-600">
            {t("Contacts:until")} {moment(endDateValue).format("MMM Do YYYY")}
          </p>
        )}
      </div>
    </div>
  );
};
